<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">My Calendar</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button class="btn add-btn" @click="showAddEvent">
            <i class="fa fa-plus"></i>Add Event
          </button>
          <button class="btn add-btn mr-1" @click="showEditEvent" v-if="id">
            <i class="fa fa-pencil"></i>Edit Event
          </button>
          <button
            class="btn btn-danger add-btn mr-1"
            @click="removeEvent"
            v-if="id"
          >
            <i class="fa fa-trash"></i>Delete Event
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Calendar -->
    <div class="row parent-div">
      <div class="col-3 cal-div">
        <div class="card mb-3 ph-div" v-if="countries && countries.length">
          <div class="card-body p-3">
            <table class="table table-bordered custom-table mb-0 ph-table">
              <thead class="thead-light">
                <tr>
                  <th class="d-flex align-items-center">
                    <input
                      type="checkbox"
                      id="chkAllPh"
                      class="mr-1"
                      v-model="showAllPh"
                      @change="showAllPhCheckChange"
                    />
                    <label
                      for="chkAllPh"
                      style="margin-top: 3px; margin-bottom: 0"
                    >
                      Show Public Holidays
                    </label>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div
                      v-for="item in countries"
                      :key="item.Id"
                      class="d-flex align-items-center"
                    >
                      <input
                        :id="`chk${item.Id}`"
                        type="checkbox"
                        class="mr-1"
                        v-model="item.Selected"
                        @change="countryCheckChange"
                      />
                      <label
                        :for="`chk${item.Id}`"
                        style="margin-top: 3px; margin-bottom: 0"
                      >
                        {{ item.Name }}
                      </label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <v-date-picker
          :first-day-of-week="0"
          :model-config="modelConfig"
          :key="counter"
          v-model="selectedDate"
        />
      </div>
      <div class="schedule-div px-md-0 px-lg-0">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-8">
                <div class="navigation-div">
                  <button class="btn btn-light mr-3" @click="today">
                    Today
                  </button>
                  <button class="btn btn-light mr-3" @click="previous">
                    <i class="fas fa-less-than"></i>
                  </button>
                  <button class="btn btn-light mr-3" @click="next">
                    <i class="fas fa-greater-than"></i>
                  </button>
                  <label class="period-lbl" style="margin-bottom: 0 !important">
                    <h5 style="margin-bottom: 0 !important">
                      {{ displayedPeriod }}
                    </h5>
                  </label>
                </div>
              </div>
              <div class="col-4">
                <div class="navigation-div text-right">
                  <button
                    :class="
                      selectedView == 'Day'
                        ? 'selected btn btn-light mr-3'
                        : 'btn btn-light mr-3'
                    "
                    @click="changeView('Day')"
                  >
                    Day
                  </button>
                  <button
                    :class="
                      selectedView == 'Week'
                        ? 'selected btn btn-light mr-3'
                        : 'btn btn-light mr-3'
                    "
                    @click="changeView('Week')"
                  >
                    Week
                  </button>
                  <button
                    :class="
                      selectedView == 'Month'
                        ? 'selected btn btn-light'
                        : 'btn btn-light'
                    "
                    @click="changeView('Month')"
                  >
                    Month
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <component
                  :is="selectedView"
                  :selectedDate="selectedDate"
                  :selectedCountries="selectedCountries"
                  :instructorId="tokenObj.Id"
                  @showMore="showMore"
                  @selectEvent="selectEvent"
                  @showAddEventFromComponent="showAddEventFromComponent"
                  @showEditEventFromComponent="showEditEventFromComponent"
                  @showPublicHoliday="showPublicHoliday"
                  :key="counter"
                ></component>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Calendar -->

    <!-- Add Event Modal -->
    <div class="modal custom-modal fade" id="addEventModal" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header pt-4">
            <h5 class="modal-title">Add Event</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pt-3">
            <form @submit.prevent="addEvent">
              <div class="form-group">
                <label class="mb-0">
                  Event Name<span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  v-model="new_eventName"
                  class="form-control"
                  maxlength="100"
                  required
                />
              </div>
              <div class="form-group">
                <label class="mb-0">Location</label>
                <input
                  type="text"
                  v-model="new_location"
                  class="form-control"
                  maxlength="100"
                />
              </div>
              <div class="form-group">
                <label class="mb-0">
                  Date<span class="text-danger">*</span>
                </label>
                <input
                  type="date"
                  class="form-control"
                  v-model="new_date"
                  required
                />
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="form-group col-md-6 mb-0">
                    <label class="mb-0">
                      Start Time<span class="text-danger">*</span>
                    </label>
                    <div class="d-flex align-items-center">
                      <select
                        v-model="new_startHour"
                        class="form-control form-control-sm fit-content"
                        required
                      >
                        <option value>0</option>
                        <option
                          v-for="item in timingHours"
                          :value="item"
                          :key="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <span class="mx-1">:</span>
                      <select
                        v-model="new_startMinute"
                        class="form-control form-control-sm fit-content"
                      >
                        <option
                          v-for="item in timingMinutes"
                          :value="item"
                          :key="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <select
                        v-model="new_startTimePart"
                        class="form-control form-control-sm ml-2 fit-content"
                      >
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-6 mb-0 mt-2 mt-md-0 mt-lg-0">
                    <label class="mb-0">
                      End Time<span class="text-danger">*</span>
                    </label>
                    <div class="d-flex align-items-center">
                      <select
                        v-model="new_endHour"
                        class="form-control form-control-sm fit-content"
                        required
                      >
                        <option value>0</option>
                        <option
                          v-for="item in timingHours"
                          :value="item"
                          :key="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <span class="mx-1">:</span>
                      <select
                        v-model="new_endMinute"
                        class="form-control form-control-sm fit-content"
                      >
                        <option
                          v-for="item in timingMinutes"
                          :value="item"
                          :key="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <select
                        v-model="new_endTimePart"
                        class="form-control form-control-sm ml-2 fit-content"
                      >
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="mb-0">Notes</label>
                <textarea
                  class="form-control"
                  maxlength="200"
                  v-model="new_notes"
                ></textarea>
              </div>
              <!-- Button -->
              <div class="submit-section mt-4">
                <button type="submit" class="btn btn-primary submit-btn">
                  Add
                </button>
              </div>
              <!-- /Button -->
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- /Add Event Modal -->

    <!-- Edit Event Modal -->
    <div class="modal custom-modal fade" id="editEventModal" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header pt-4">
            <h5 class="modal-title">Edit Event</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pt-3">
            <form @submit.prevent="updateEvent">
              <div class="form-group">
                <label class="mb-0">
                  Event Name<span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  v-model="eventName"
                  class="form-control"
                  maxlength="100"
                  required
                />
              </div>
              <div class="form-group">
                <label class="mb-0">Location</label>
                <input
                  type="text"
                  v-model="location"
                  class="form-control"
                  maxlength="100"
                />
              </div>
              <div class="form-group">
                <label class="mb-0">
                  Date<span class="text-danger">*</span>
                </label>
                <input
                  type="date"
                  class="form-control"
                  v-model="date"
                  required
                />
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="form-group col-md-6 mb-0">
                    <label class="mb-0">
                      Start Time<span class="text-danger">*</span>
                    </label>
                    <div class="d-flex align-items-center">
                      <select
                        v-model="startHour"
                        class="form-control form-control-sm fit-content"
                        required
                      >
                        <option value>0</option>
                        <option
                          v-for="item in timingHours"
                          :value="item"
                          :key="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <span class="mx-1">:</span>
                      <select
                        v-model="startMinute"
                        class="form-control form-control-sm fit-content"
                      >
                        <option
                          v-for="item in timingMinutes"
                          :value="item"
                          :key="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <select
                        v-model="startTimePart"
                        class="form-control form-control-sm ml-2 fit-content"
                      >
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-6 mb-0 mt-2 mt-md-0 mt-lg-0">
                    <label class="mb-0">
                      End Time<span class="text-danger">*</span>
                    </label>
                    <div class="d-flex align-items-center">
                      <select
                        v-model="endHour"
                        class="form-control form-control-sm fit-content"
                        required
                      >
                        <option value>0</option>
                        <option
                          v-for="item in timingHours"
                          :value="item"
                          :key="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <span class="mx-1">:</span>
                      <select
                        v-model="endMinute"
                        class="form-control form-control-sm fit-content"
                      >
                        <option
                          v-for="item in timingMinutes"
                          :value="item"
                          :key="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <select
                        v-model="endTimePart"
                        class="form-control form-control-sm ml-2 fit-content"
                      >
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="mb-0">Notes</label>
                <textarea
                  class="form-control"
                  maxlength="200"
                  v-model="notes"
                ></textarea>
              </div>
              <!-- Button -->
              <div class="submit-section mt-4">
                <button type="submit" class="btn btn-primary submit-btn">
                  Update
                </button>
              </div>
              <!-- /Button -->
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- /Edit Event Modal -->

    <!-- Public Holiday Modal -->
    <div class="modal custom-modal fade" id="phModal" role="dialog">
      <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header pb-0" style="border: 1px solid #dee2e6">
            <h5 class="modal-title">Public Holiday</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body px-3 pt-3 pb-0">
            <form>
              <div class="form-group">
                <label class="mb-0"><b>Event Name</b></label>
                <div>{{ eventName }}</div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="form-group col-6 mb-0">
                    <label class="mb-0"><b>Date</b></label>
                    <div>{{ date }}</div>
                  </div>
                  <div class="form-group col-6 mb-0">
                    <label class="mb-0"><b>Country</b></label>
                    <div>{{ country }}</div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Public Holiday Modal-->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import Month from "./MyCalendarMonth.vue";
import Week from "./MyCalendarWeek.vue";
import Day from "./MyCalendarDay.vue";
import $ from "jquery";
export default {
  components: {
    Month,
    Week,
    Day,
  },
  data() {
    return {
      selectedView: "Month",
      selectedDate: "",
      modelConfig: {
        type: "string",
        mask: "YYYY-MM-DD",
      },
      displayedPeriod: "",
      counter: 0,
      //for ph
      showAllPh: false,
      countries: [],
      selectedCountries: [],
      //for edit modal
      id: "",
      eventName: "",
      location: "",
      date: "",
      startHour: "",
      startMinute: "00",
      startTimePart: "AM",
      endHour: "",
      endMinute: "00",
      endTimePart: "AM",
      notes: "",
      country: "",
      //for add modal
      new_id: "",
      new_eventName: "",
      new_location: "",
      new_date: "",
      new_startHour: "",
      new_startMinute: "00",
      new_startTimePart: "AM",
      new_endHour: "",
      new_endMinute: "00",
      new_endTimePart: "AM",
      new_notes: "",
      new_country: "",
    };
  },

  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
    timingHours() {
      let hours = [];
      for (let i = 1; i <= 12; i++) {
        hours.push(i);
      }
      return hours;
    },
    timingMinutes() {
      let minutes = [];
      for (let i = 0; i <= 59; i++) {
        minutes.push(i.toString().padStart(2, "0"));
      }
      return minutes;
    },
    todayDate() {
      let date = new Date();
      let day = date.getDate().toString().padStart(2, "0");
      let month = (date.getMonth() + 1).toString().padStart(2, "0");
      let year = date.getFullYear();
      return `${year}-${month}-${day}`;
    },
  },

  watch: {
    selectedDate(val) {
      if (val) {
        this.getDisplayedPeriod();
        this.counter++;
        this.resetEditEvent();
      }
    },
    selectedView() {
      if (!this.selectedDate) this.selectedDate = this.todayDate;
      this.getDisplayedPeriod();
      this.counter++;
      this.resetEditEvent();
    },
    "$store.state.expandSidebar": function (val) {
      this.resize();
    },
  },

  methods: {
    changeView(view) {
      this.selectedView = view;
    },
    today() {
      this.selectedDate = this.todayDate;
    },
    previous() {
      let param = {
        Token: this.tokenObj.Token,
        Date: this.selectedDate,
        View: this.selectedView,
      };
      this.$store.state.isLoading = true;
      API.schedule
        .getPreviousDate(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.selectedDate = response.data.previousDate;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    next() {
      let param = {
        Token: this.tokenObj.Token,
        Date: this.selectedDate,
        View: this.selectedView,
      };
      this.$store.state.isLoading = true;
      API.schedule
        .getNextDate(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.selectedDate = response.data.nextDate;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getDisplayedPeriod() {
      let param = {
        Token: this.tokenObj.Token,
        Date: this.selectedDate,
        View: this.selectedView,
      };
      this.$store.state.isLoading = true;
      API.schedule
        .getDisplayedPeriod(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.displayedPeriod = response.data.displayedPeriod;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    showMore(date) {
      this.selectedView = "Day";
      this.selectedDate = date;
      this.counter++;
    },
    selectEvent(payload) {
      this.id = payload.Id;
      this.eventName = payload.EventName;
      this.location = payload.Location;
      this.date = payload.CalendarDate;
      this.startHour = payload.StartHour;
      this.startMinute = payload.StartMinute.toString().padStart(2, "0");
      this.startTimePart = payload.StartTimePart;
      this.endHour = payload.EndHour;
      this.endMinute = payload.EndMinute.toString().padStart(2, "0");
      this.endTimePart = payload.EndTimePart;
      this.notes = payload.Notes;
    },
    getInstructorCountries() {
      API.instructor
        .getInstructorCountries({
          Token: this.tokenObj.Token,
          Id: this.tokenObj.Id,
        })
        .then((response) => {
          if (response.data.success) {
            this.countries = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //for ph
    showAllPhCheckChange() {
      for (let item of this.countries) {
        item.Selected = this.showAllPh;
      }
      this.selectedCountries = this.showAllPh
        ? this.countries.map((c) => c.Id)
        : [];
      this.counter++;
    },
    countryCheckChange() {
      this.selectedCountries = this.countries
        .filter((c) => c.Selected == true)
        .map((c) => c.Id);
      this.showAllPh = this.selectedCountries.length == this.countries.length;
      this.counter++;
    },
    showPublicHoliday(payload) {
      if (payload) {
        this.eventName = payload.eventName;
        this.date = payload.date;
        this.country = payload.country;
        $("#phModal").modal("show");
      }
    },
    //modal add and edit
    resetAddEvent() {
      this.new_id = "";
      this.new_eventName = "";
      this.new_location = "";
      this.new_date = "";
      this.new_startHour = "";
      this.new_startMinute = "00";
      this.new_startTimePart = "AM";
      this.new_endHour = "";
      this.new_endMinute = "00";
      this.new_endTimePart = "AM";
      this.new_notes = "";
    },
    resetEditEvent() {
      this.id = "";
      this.eventName = "";
      this.location = "";
      this.date = "";
      this.startHour = "";
      this.startMinute = "00";
      this.startTimePart = "AM";
      this.endHour = "";
      this.endMinute = "00";
      this.endTimePart = "AM";
      this.notes = "";
    },
    showAddEvent() {
      this.resetAddEvent();
      if (this.selectedView == "Day") this.new_date = this.selectedDate;
      $("#addEventModal").modal("show");
    },
    showAddEventFromComponent(payload) {
      this.resetAddEvent();
      if (payload) {
        this.new_date = payload.date;
        this.new_startHour = payload.startHour;
        this.new_startMinute = payload.startMinute;
        this.new_startTimePart = payload.startTimePart;
      }
      $("#addEventModal").modal("show");
    },
    showEditEvent() {
      $("#editEventModal").modal("show");
    },
    showEditEventFromComponent(payload) {
      this.resetEditEvent();
      if (payload) {
        this.id = payload.id;
        this.eventName = payload.eventName;
        this.location = payload.location;
        this.date = payload.date;
        this.startHour = payload.startHour;
        this.startMinute = payload.startMinute;
        this.startTimePart = payload.startTimePart;
        this.endHour = payload.endHour;
        this.endMinute = payload.endMinute;
        this.endTimePart = payload.endTimePart;
        this.notes = payload.notes;
      }
      $("#editEventModal").modal("show");
    },
    addEvent() {
      //validation
      if (
        (this.new_startHour != "" || this.new_startMinute != "") &&
        (this.new_endHour != "" || this.new_endMinute != "")
      ) {
        let startHour =
          this.new_startHour != "" ? parseInt(this.new_startHour) : 0;
        let startMinute =
          this.new_startMinute != "" ? parseInt(this.new_startMinute) : 0;
        let totalStartTimeMinutes =
          (this.new_startTimePart == "AM"
            ? startHour == 12
              ? 0
              : startHour
            : startHour < 12
            ? startHour + 12
            : 12) *
            60 +
          startMinute;

        let endHour = this.new_endHour != "" ? parseInt(this.new_endHour) : 0;
        let endMinute =
          this.new_endMinute != "" ? parseInt(this.new_endMinute) : 0;
        let totalEndTimeMinutes =
          (this.new_endTimePart == "AM"
            ? endHour == 12
              ? 0
              : endHour
            : endHour < 12
            ? endHour + 12
            : 12) *
            60 +
          endMinute;

        if (totalEndTimeMinutes <= totalStartTimeMinutes) {
          this.$swal("End Time must be later than Start Time", {
            icon: "error",
          });
          return;
        }
      }
      //save
      let param = {
        Token: this.tokenObj.Token,
        Id: this.new_id,
        EventName: this.new_eventName,
        Location: this.new_location,
        CalendarDate: this.new_date,
        StartHour: this.new_startHour,
        StartMinute: this.new_startMinute,
        StartTimePart: this.new_startTimePart,
        EndHour: this.new_endHour,
        EndMinute: this.new_endMinute,
        EndTimePart: this.new_endTimePart,
        Notes: this.new_notes,
      };
      API.schedule
        .saveEvent(param)
        .then((response) => {
          if (!response.data.success)
            this.$swal(response.data.message, { icon: "error" });
          if (response.data.success) {
            this.selectedDate = this.new_date;
            this.counter++;
            $("#addEventModal").modal("hide");
            this.resetAddEvent();
            this.resetEditEvent();
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    updateEvent() {
      //validation
      if (
        (this.startHour != "" || this.startMinute != "") &&
        (this.endHour != "" || this.endMinute != "")
      ) {
        let startHour = this.startHour != "" ? parseInt(this.startHour) : 0;
        let startMinute =
          this.startMinute != "" ? parseInt(this.startMinute) : 0;
        let totalStartTimeMinutes =
          (this.startTimePart == "AM"
            ? startHour == 12
              ? 0
              : startHour
            : startHour < 12
            ? startHour + 12
            : 12) *
            60 +
          startMinute;

        let endHour = this.endHour != "" ? parseInt(this.endHour) : 0;
        let endMinute = this.endMinute != "" ? parseInt(this.endMinute) : 0;
        let totalEndTimeMinutes =
          (this.endTimePart == "AM"
            ? endHour == 12
              ? 0
              : endHour
            : endHour < 12
            ? endHour + 12
            : 12) *
            60 +
          endMinute;

        if (totalEndTimeMinutes <= totalStartTimeMinutes) {
          this.$swal("End Time must be later than Start Time", {
            icon: "error",
          });
          return;
        }
      }
      //save
      let param = {
        Token: this.tokenObj.Token,
        Id: this.id,
        EventName: this.eventName,
        Location: this.location,
        CalendarDate: this.date,
        StartHour: this.startHour,
        StartMinute: this.startMinute,
        StartTimePart: this.startTimePart,
        EndHour: this.endHour,
        EndMinute: this.endMinute,
        EndTimePart: this.endTimePart,
        Notes: this.notes,
      };
      API.schedule
        .saveEvent(param)
        .then((response) => {
          if (!response.data.success)
            this.$swal(response.data.message, { icon: "error" });
          if (response.data.success) {
            this.selectedDate = this.date;
            this.counter++;
            $("#editEventModal").modal("hide");
            this.resetEditEvent();
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    removeEvent() {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.id,
      };
      API.schedule
        .deleteEvent(param)
        .then((response) => {
          if (!response.data.success)
            this.$swal(response.data.message, { icon: "error" });
          if (response.data.success) {
            this.counter++;
            this.resetEditEvent();
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //resize function
    resize() {
      window.setTimeout(() => {
        this.updateSize();
      }, 300);
    },
    updateSize() {
      let windowWidth = $(window).width();
      let scaleFactor = 1;
      let parentDivWidth = 1212.8;
      let sidebarWidth = $("div.sidebar").outerWidth();
      if (windowWidth > 1368) {
        $("div.parent-div").css({
          transform: `scale(${scaleFactor})`,
          width: "unset",
        });
      } else {
        let factor = 0.94;
        if (windowWidth > 991.98) {
          if (sidebarWidth < 61) {
            parentDivWidth = 1382.8;
            if (windowWidth >= 1351) {
              factor = 0.922;
            } else if (windowWidth >= 1165) {
              factor = 0.905;
            } else if (windowWidth >= 1009) {
              factor = 0.89;
            }
          } else {
            parentDivWidth = 1212.8;
            if (windowWidth >= 1351) {
              factor = 0.8;
            } else if (windowWidth >= 1165) {
              factor = 0.76;
            } else if (windowWidth >= 1009) {
              factor = 0.725;
            }
          }
        }
        scaleFactor = (windowWidth * factor) / parentDivWidth;
        // console.log("windoWidth", windowWidth);
        // console.log("factor", factor);
        // console.log("parentDivWidth", parentDivWidth);
        // console.log("scaleFactor", scaleFactor);
        $("div.parent-div").css({
          transform: `scale(${scaleFactor})`,
          width: parentDivWidth + "px",
        });
      }
      $("div.parent-div").css("transform-origin", `15px 0px`);
    },
  },

  created() {
    this.selectedDate = this.todayDate;
    this.getInstructorCountries();
  },

  mounted() {
    this.resize();
    window.addEventListener("resize", this.resize);
    //adjust word-spacing
    let userAgent = navigator.userAgent;
    let platform = navigator.userAgentData.platform || navigator.platform;
    let isWindow = /Win/i.test(platform);
    let isAndroid = /Android/i.test(userAgent);
    let isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
    let isMacos = /Mac/i.test(platform);
    if (isWindow || isAndroid || (isMacos && !isSafari)) {
      $(".ph-div").css("word-spacing", "-5px");
    }
  },
};
</script>

<style scoped>
.cal-div {
  max-width: fit-content;
  margin-bottom: 20px;
}
.ph-div {
  width: 251.6px;
}
.ph-table {
  width: 100% !important;
}
.ph-div label,
.ph-div input[type="checkbox"] {
  cursor: pointer;
  text-align: left;
}
.ph-div .table thead th,
.ph-div .table tbody td {
  letter-spacing: 0px;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  white-space: unset;
  line-height: 17px;
}
.schedule-div {
  flex: 1;
}
.selected {
  background-color: #e2e6ea;
}
button.btn-danger {
  background: #f62d51 !important;
  border: 1px solid #f62d51 !important;
}
table {
  width: 100% !important;
}

/* @media only screen and (max-width: 1199.98px) {
  table {
    width: 100% !important;
  }
  div.parent-div {
    zoom: 60% !important;
  }
} */

/* @media only screen and (max-width: 1024px) {
  div.parent-div {
    zoom: 40% !important;
  }
} */

/* @media only screen and (max-width: 767.98px) {
  div.parent-div {
    zoom: 60% !important;
  }
} */

/* @media only screen and (max-width: 575.98px) {
  div.parent-div {
    zoom: 50% !important;
  }
} */

@media only screen and (max-width: 431px) {
  /* div.parent-div {
    zoom: 30% !important;
  } */
  /* div.col-auto {
    zoom: 50% !important;
    margin-right: 5px;
  }*/
  .page-header {
    margin-bottom: 20px;
  }
  button.add-btn {
    font-size: 8px;
    max-width: fit-content !important;
    padding-top: 2px;
    padding-bottom: 1px;
    padding-left: 6px;
    padding-right: 6px;
  }
  h3.page-title {
    font-size: 14px;
    margin-bottom: 0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolUser/Other/MyCalendar.vue